import angular from 'angular';

import {
  signCertificataController,
  digitalizationLinkController,
  baseController,
  checkoutsController,
  digitalizationsController,
  documentsController,
  documentsSearchController,
  favoritesController,
  myDeadLinesController,
  myExpiredDocController,
  notificationsController,
  propertiesController,
  publicLinksController,
  shareDocumentsController,
  sharedsController,
  trashCanController,
  uploadsController,
  flowController,
  flowSelectGroupsController,
  runWorkflowController,
  workflowBaseController,
  workflowController,
  formsController,
  personalizationController,
  systemConfigurationController,
  mediaController,
  mediaListController,
  mediaModalController,
  adminController,
  baseHomeController,
  chatbotController,
  crudController,
  folderController,
  forgotPasswordController,
  homeController,
  linkedDocumentsController,
  loginController,
  pickFolderController,
  publicFolderLinkController,
  publicLinkController,
  recoverPasswordController,
  searchController,
  sendByEmailController,
  sendFilesController,
  supportController,
  timecheckController,
  treeController,
  userController,
  viewerController,
  cancelCheckoutModalController,
  cancelPasswordModalController,
  deleteModalController,
  linkFileModalController,
  obsoleteDocumentModalController,
  questionModalController,
  removeDocumentModalController,
  removePermantlyModalController,
  nfeController,
  nfeListController,
  nfeModalController,
  activeUsersController,
  additionalFieldsController,
  auditUserController,
  dashboardController,
  expiredRevisionsController,
  indexedPagesController,
  inventoryController,
  logViewController,
  pendingSubscriptionController,
  pickReportController,
  publicLinkReportController,
  reportController,
  sharedFoldersReportController,
  crudGroupController,
  securityController,
  signDocumentsController,
  signDocumentsD4sController,
  signedDocumentSealController,
} from '../controllers';

const module = 'app.controllers';
const requires = [];

angular.module(module, requires);

angular.module(module).registerComponents(
  {
    signCertificataController,
    digitalizationLinkController,
    baseController,
    checkoutsController,
    digitalizationsController,
    documentsController,
    documentsSearchController,
    favoritesController,
    myDeadLinesController,
    myExpiredDocController,
    notificationsController,
    propertiesController,
    publicLinksController,
    shareDocumentsController,
    sharedsController,
    trashCanController,
    uploadsController,
    flowController,
    flowSelectGroupsController,
    runWorkflowController,
    workflowBaseController,
    workflowController,
    formsController,
    personalizationController,
    systemConfigurationController,
    mediaController,
    mediaListController,
    mediaModalController,
    adminController,
    baseHomeController,
    chatbotController,
    crudController,
    folderController,
    forgotPasswordController,
    homeController,
    linkedDocumentsController,
    loginController,
    pickFolderController,
    publicFolderLinkController,
    publicLinkController,
    recoverPasswordController,
    searchController,
    sendByEmailController,
    sendFilesController,
    supportController,
    timecheckController,
    treeController,
    userController,
    viewerController,
    cancelCheckoutModalController,
    cancelPasswordModalController,
    deleteModalController,
    linkFileModalController,
    obsoleteDocumentModalController,
    questionModalController,
    removeDocumentModalController,
    removePermantlyModalController,
    nfeController,
    nfeListController,
    nfeModalController,
    activeUsersController,
    additionalFieldsController,
    auditUserController,
    dashboardController,
    expiredRevisionsController,
    indexedPagesController,
    inventoryController,
    logViewController,
    pendingSubscriptionController,
    pickReportController,
    publicLinkReportController,
    reportController,
    sharedFoldersReportController,
    crudGroupController,
    securityController,
    signDocumentsController,
    signDocumentsD4sController,
    signedDocumentSealController,
  },
  'controller'
);
